import { Button } from "@/components/ui/button";
import { useThemeStore } from "@/stores/useThemeStore";
import { Palette } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const ThemeSelector = () => {
  const { theme, setTheme } = useThemeStore();

  const themes = [
    { name: 'light' as const, label: 'Light', color: 'bg-zinc-50' },
    { name: 'dark' as const, label: 'Dark', color: 'bg-zinc-950' },
    { name: 'forest' as const, label: 'Forest', color: 'bg-emerald-600' },
    { name: 'purple' as const, label: 'Purple', color: 'bg-purple-600' },
    { name: 'ocean' as const, label: 'Ocean', color: 'bg-blue-600' },
    { name: 'sunset' as const, label: 'Sunset', color: 'bg-orange-600' },
    { name: 'rose' as const, label: 'Rose', color: 'bg-rose-600' },
    { name: 'amber' as const, label: 'Amber', color: 'bg-amber-600' },
    { name: 'teal' as const, label: 'Teal', color: 'bg-teal-600' },
  ] as const;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Palette className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {themes.map(({ name, label, color }) => (
          <DropdownMenuItem
            key={name}
            onClick={() => setTheme(name)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className={`w-4 h-4 rounded-full ${color}`} />
            <span className={theme === name ? "font-medium" : ""}>{label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};